import { jsx as _jsx } from "react/jsx-runtime";
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import Small from 'UIComponents/elements/Small';
export const ErrorMessage = ({
  dataKey,
  explicitMessageKey = null
}) => {
  return /*#__PURE__*/_jsx("div", {
    className: "m-top-2",
    children: /*#__PURE__*/_jsx(Small, {
      className: "ErrorMessage",
      use: "error",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `data.${dataKey}.${explicitMessageKey || 'errorText'}`
      })
    })
  });
};